import { render } from "./VideoMaster.vue?vue&type=template&id=6c74f0ea&scoped=true"
import script from "./VideoMaster.vue?vue&type=script&lang=js"
export * from "./VideoMaster.vue?vue&type=script&lang=js"

import "./VideoMaster.vue?vue&type=style&index=0&id=6c74f0ea&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\CMRF\\cmrf_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c74f0ea"]])

export default __exports__